import React from "react";
import { Row, Button, Modal } from "react-bootstrap";
import {
  editContactAction,
  getContactByIdAction,
  getUserRolesAction,
  addUserRolesAction,
} from "../../actions/UserActions";
import { connect } from "react-redux";
import * as Yup from "yup";
import { Field, Form, Formik, ErrorMessage } from "formik";
import InputMask from "react-input-mask";
import { cryptoTokenDecode } from "./../Common/Common";
import * as message from "./../../config/CommonMessages";
import UrlConstants from "../../config/UrlConstants";
import { HexColorInput, HexColorPicker } from "react-colorful";

class EditContact extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isEmailValid: false,
      roleForPopup: this.props.roleForPopup,
      roleIdForPopup: this.props.roleIdForPopup,
      contact: {
        role: "",
        usertype: "",
        firstname: "",
        lastname: "",
        mobileNumber: "",
        email: "",
        color: "",
        showLoader: false,
      },
      editable: false,
    };
  }

  componentDidMount() {
    this.setState({
      showLoader: true,
    });
    this.props.getUserRolesAction().catch((err) => {});
    this.props
      .getContactByIdAction(this.props.contactData.id)
      .then((res) => {
        this.setState({ editable: this.props.contact.isPasswordSet });
        this.setState({ contact: this.props.contact });
        this.setState({
          showLoader: false,
        });
      })
      .catch((err) => {});
  }

  next() {
    this.setState({
      page: 1,
    });
  }

  /**
   * @desc update contact details
   * check if user selected custom role then first add that role using api
   * and then add user/contact with details by add contact api
   */
  updateContact(values) {
    this.setState({
      showLoader: true,
    });
    var dataToPut = {
      roles: values.roles,
      default: values.default,
      firstname: values.firstname,
      lastname: values.lastname,
      mobileNumber: values.mobileNumber,
      isPasswordSet: values.isPasswordSet,
      color: values.color,
    };

    this.props
      .editContactAction(dataToPut, this.props.contact.contactId)
      .then((res) => {
        this.setState({
          showLoader: false,
        });
        this.props.onClose();
      });
  }

  setFieldValue(name, e) {
    var contact = this.state.contact;
    contact[name] = e;
    this.setState({
      contact,
    });
  }
  setMobile(value, field, setFieldValue) {
    var mob = value.replace(/-/g, "");
    setFieldValue(field, mob);
  }

  handleColorAvailability(color, isColorUsed) {
    let contactColors = [];

    for (let i = 0; i < this.props.contacts.length; i++) {
      let contactColor = this.props.contacts[i].color;
      contactColors.push(contactColor);
      if (contactColors.includes(color)) {
        isColorUsed = true;
      } else {
        isColorUsed = false;
      }
    }

    return isColorUsed;
  }

  render() {
    return (
      <div>
        {this.state.showLoader && (
          <div className="page-loader">
            <div className="page-loader-inner">
              <div className="spinner-border" role="status">
                <span className="sr-only">Loading...</span>
              </div>
            </div>
          </div>
        )}
        <Modal.Body>
          <Formik
            validateOnBlur={true}
            initialValues={this.state.contact}
            enableReinitialize={true}
            validationSchema={Yup.object().shape({
              firstname: Yup.string()
                .trim()
                .required(message.ENTER_FIRST_NAME),
              lastname: Yup.string()
                .trim()
                .required(message.ENTER_LAST_NAME),
              roles: Yup.string().trim(),
              mobileNumber: Yup.string()
                .nullable()
                .required(message.ENTER_MOBILE_NUMBER)
                .test("mobileNumber", message.ENTER_VALID_MOBILE, (value) => {
                  if ((value || "").length == 10) {
                    return true;
                  }
                  return false;
                }),
            })}
            onSubmit={(values) => {
              values.roles = document.getElementById("ddlRoles").value;
              this.updateContact(values);
              // console.log('updateContact: ', values);
            }}
          >
            {({ handleChange, values, errors, setFieldValue }) => (
              <Form className="form-sm form-admin">
                <>
                  <div className="form-group">
                    <label>Email</label>
                    <Field
                      type="email"
                      className="form-control"
                      name="email"
                      value={values.email}
                      disabled
                      handleChange={handleChange}
                    />
                  </div>
                  <div className="form-group">
                    <label>
                      Role<span className="text-danger"> *</span>
                    </label>
                    <div className="c-select">
                      {this.state.roleIdForPopup == undefined ? (
                        <select
                          className="form-control"
                          id="ddlRoles"
                          name="roles"
                          value={values.role}
                          onChange={(e) => {
                            setFieldValue("roles", e.target.value);
                          }}
                          disabled
                        >
                          {/* {this.props.roles &&
                            this.props.roles.map(role => {
                              return <option value={role._id}>{role.name}</option>
                            })
                          } */}

                          {this.props.roles &&
                            this.props.roles
                              .filter((role) =>
                                window.location.href ===
                                UrlConstants.SiteUrl + "contacts"
                                  ? role.name === "Artist"
                                  : role.name === "Client"
                              )
                              .map((role) => {
                                return (
                                  <option value={role._id}>{role.name}</option>
                                );
                              })}
                        </select>
                      ) : (
                        <select
                          className="form-control"
                          id="ddlRoles"
                          name="roles"
                          value={this.state.roleIdForPopup}
                          onChange={(e) => {
                            setFieldValue("roles", e.target.value);
                          }}
                          disabled
                        >
                          <option value={this.state.roleIdForPopup}>
                            {this.state.roleForPopup}
                          </option>
                        </select>
                      )}
                    </div>
                    <ErrorMessage
                      name="roles[0]"
                      component="div"
                      className="invalid-feedback"
                      style={{ display: "block" }}
                    />
                  </div>
                </>

                <div className="form-group">
                  <label>
                    First Name
                    {this.state.editable === false ? (
                      <span className="text-danger"> *</span>
                    ) : (
                      ""
                    )}
                  </label>
                  <Field
                    type="text"
                    name="firstname"
                    className="form-control"
                    value={values.firstname}
                    disabled={this.state.editable}
                    handleChange={handleChange}
                  />
                  <ErrorMessage
                    name="firstname"
                    component="div"
                    className="invalid-feedback"
                    style={{ display: "block" }}
                  />
                </div>
                <div className="form-group">
                  <label>
                    Last Name
                    {this.state.editable === false ? (
                      <span className="text-danger"> *</span>
                    ) : (
                      ""
                    )}
                  </label>
                  <Field
                    type="text"
                    name="lastname"
                    className="form-control"
                    value={values.lastname}
                    disabled={this.state.editable}
                    handleChange={handleChange}
                  />
                  <ErrorMessage
                    name="lastname"
                    component="div"
                    className="invalid-feedback"
                    style={{ display: "block" }}
                  />
                </div>
                <div className="form-group">
                  <label>
                    Phone
                    {this.state.editable === false ? (
                      <span className="text-danger"> *</span>
                    ) : (
                      ""
                    )}
                  </label>
                  <InputMask
                    mask="999-999-9999"
                    maskChar=""
                    formControlProps={{
                      fullWidth: true,
                    }}
                    className={`form-control ${
                      this.state.editable ? "disabled pointer-none" : ""
                    }`}
                    value={values.mobileNumber}
                    name="mobileNumber"
                    onChange={(e) => {
                      this.setMobile(
                        e.target.value,
                        "mobileNumber",
                        setFieldValue
                      );
                    }}
                  >
                    {(inputProps) => <Field {...inputProps} />}
                  </InputMask>
                  <ErrorMessage
                    name="mobileNumber"
                    component="div"
                    className="invalid-feedback"
                    style={{ display: "block" }}
                  />
                </div>
                {window.location.href ===
                  UrlConstants.SiteUrl + "contactsnew" ||
                window.location.href === UrlConstants.SiteUrl + "contacts" ? (
                  <div>
                    <label>
                      Choose a Color<span className="text-danger"> *</span>
                    </label>
                    <Row className="ml-1 mb-4 mt-2">
                      <HexColorPicker
                        color={this.state.contact.color}
                        onChange={(e) => setFieldValue("color", e)}
                        style={{ width: "420px", height: "100px" }}
                      />
                    </Row>
                    {/* <Row className='ml-1 mb-2'>
                          <button
                            onClick={() => setFieldValue("color", "red")}
                            value={values.color}
                            className='contact-color-btn-red'
                            disabled={this.handleColorAvailability("red", true)}
                          />
                          <button
                            onClick={() => setFieldValue("color", "orange")}
                            value={values.color}
                            className='contact-color-btn-orange'
                            disabled={this.handleColorAvailability("orange", true)}
                          />
                          <button
                            onClick={() => setFieldValue("color", "gold")}
                            value={values.color}
                            className='contact-color-btn-gold'
                            disabled={this.handleColorAvailability("gold", true)}
                          />
                          <button
                            onClick={() => setFieldValue("color", "green")}
                            value={values.color}
                            className='contact-color-btn-green'
                            disabled={this.handleColorAvailability("green", true)}
                          />
                          <button
                            onClick={() => setFieldValue("color", "blue")}
                            value={values.color}
                            className='contact-color-btn-blue'
                            disabled={this.handleColorAvailability("blue", true)}
                          />
                          <button
                            onClick={() => setFieldValue("color", "purple")}
                            value={values.color}
                            className='contact-color-btn-purple'
                            disabled={this.handleColorAvailability("purple", true)}
                          />
                        </Row>
                        <Row className='ml-1 mb-2'>
                          <button
                            onClick={() => setFieldValue("color", "pink")}
                            value={values.color}
                            className='contact-color-btn-pink'
                            disabled={this.handleColorAvailability("pink", true)}
                          />
                          <button
                            onClick={() => setFieldValue("color", "fuchsia")}
                            value={values.color}
                            className='contact-color-btn-fuchsia'
                            disabled={this.handleColorAvailability("fuchsia", true)}
                          />
                          <button
                            onClick={() => setFieldValue("color", "cyan")}
                            value={values.color}
                            className='contact-color-btn-cyan'
                            disabled={this.handleColorAvailability("cyan", true)}
                          />
                          <button
                            onClick={() => setFieldValue("color", "lime")}
                            value={values.color}
                            className='contact-color-btn-lime'
                            disabled={this.handleColorAvailability("lime", true)}
                          />
                          <button
                            onClick={() => setFieldValue("color", "darkslategray")}
                            value={values.color}
                            className='contact-color-btn-darkslategray'
                            disabled={this.handleColorAvailability("darkslategray", true)}
                          />
                          <button
                            onClick={() => setFieldValue("color", "lightcoral")}
                            value={values.color}
                            className='contact-color-btn-lightcoral'
                            disabled={this.handleColorAvailability("lightcoral", true)}
                          />
                        </Row>
                        <Row className='ml-1 mb-5'>
                          <button
                            onClick={() => setFieldValue("color", "lightgreen")}
                            value={values.color}
                            className='contact-color-btn-lightgreen'
                            disabled={this.handleColorAvailability("lightgreen", true)}
                          />
                          <button
                            onClick={() => setFieldValue("color", "lightsalmon")}
                            value={values.color}
                            className='contact-color-btn-lightsalmon'
                            disabled={this.handleColorAvailability("lightsalmon", true)}
                          />
                          <button
                            onClick={() => setFieldValue("color", "darkred")}
                            value={values.color}
                            className='contact-color-btn-darkred'
                            disabled={this.handleColorAvailability("darkred", true)}
                          />
                          <button
                            onClick={() => setFieldValue("color", "darkslateblue")}
                            value={values.color}
                            className='contact-color-btn-darkslateblue'
                            disabled={this.handleColorAvailability("darkslateblue", true)}
                          />
                          <button
                            onClick={() => setFieldValue("color", "darkcyan")}
                            value={values.color}
                            className='contact-color-btn-darkcyan'
                            disabled={this.handleColorAvailability("darkcyan", true)}
                          />
                          <button
                            onClick={() => setFieldValue("color", "darkorchid")}
                            value={values.color}
                            className='contact-color-btn-darkorchid'
                            disabled={this.handleColorAvailability("darkorchid", true)}
                          />
                        </Row> */}
                  </div>
                ) : (
                  ""
                )}
                <Button
                  variant="primary"
                  size="sm"
                  className="btn-blue w-140"
                  type="submit"
                >
                  Update
                </Button>
              </Form>
            )}
          </Formik>
        </Modal.Body>
        <Modal.Footer />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    contactResponse: state.reducer.contactResponse,
    contact: state.reducer.contact,
    roles: state.reducer.roles,
  };
};

export default connect(
  mapStateToProps,
  {
    editContactAction,
    getContactByIdAction,
    getUserRolesAction,
    addUserRolesAction,
  }
)(EditContact);
